import {AuthorListCss, indexWrapCss, widthCss} from "./css/Author.style";
import Header from "src/common/layouts/header/Header";
import Footer from "src/common/layouts/footer/Footer";
import React, { SetStateAction, useEffect, useState} from "react";
import ContentsIndex from "src/common/controls/ContentsIndex";
import {Link, useNavigate} from "react-router-dom";
import {ReactComponent as Filter} from 'src/assets/filter.svg';
import {ReactComponent as Book} from 'src/assets/authorListBook.svg';
import axios from "axios";
import Paging from '../../common/layouts/page/Paging'
import AuthorFilterModal from "../../common/layouts/modal/AuthorFilterModal";
import {ReactComponent as Close} from 'src/assets/close.svg';
import AuthorFilterContainer, { SelectedFilters } from './AtuhorFilterContainer';
import {useIsMobile} from "../../hooks/useIsMobile";
import AuthorCard from "./components/AuthorCard";

interface AuthorData {
    id: number;
    profilePhoto?: string;
    authorName: string;
    authorIntro?: string;
    authorDescription?: string;
}

const AuthorListPage = ({
                            authors,
                            currentPage,
                            totalPages,
                            onPageChange,
                            filter,
                            onFilterChange,
                        }: {
    authors: any;
    currentPage: number;
    totalPages: number;
    onPageChange: (newPage: number) => void;
    filter: { array: string[]; genre: string[]; textType: string[] };
    onFilterChange: (newFilters: { array: string[]; genre: string[]; textType: string[] }) => void;
}) => {
    const isMobile = useIsMobile();

    const [search, setSearch] = useState<any>([]);
    const imageData = Array.from({length: 12}, (_, index) => `${process.env.PUBLIC_URL}/img/goods_${index + 1}.jpg`);
    const [selectedFilters, setSelectedFilters] = useState<{ array : string[]; genre: string[]; textType: string[] }>({
        array : [],
        genre: [],
        textType: [],
    });

    const [showAlert, setShowAlert] = useState(false);
    const [filters, setFilters] = useState<SelectedFilters>({ array: [], genre: [], textType: [] });

    const handleConfirm = (newFilters: { array: string[]; genre: string[]; textType: string[] }) => {

        onFilterChange(newFilters); // 부모에게 필터 변경 전달
        setShowAlert(false);
    };
    const handleClick = () => {
            setShowAlert(true);
    };

    const onSearchHandler = (e: any) => {
        setSearch(e.target.value);
    };

    // url host
    const [hostDevMode, setHostDevMode] = useState(false);
    useEffect(() => {
        var hostDev;
        hostDev = window.location.host


      //  console.log(hostDev.includes("penpal-1409e.web.app"))
        if (hostDev.includes("penpal-1409e.web.app")) {
            setHostDevMode(true);
        }

    }, [])


    const genre = ['소설', '에세이', '시집', '수필'];


    // SBCHOI TestCOde
    const navigate = useNavigate();

    return (

    <>

        <div css={indexWrapCss}>
            <Header
                onChange={onSearchHandler}
                searchValue={search}
                name="search"
                activeFlag=""
            />

            <div css={widthCss} className={" md:!px-4 min-w-[380px] "}>
                <div className={"flex flex-col gap-[62px] md:gap-[35px]"}>

                    <div>
                        <span className={"text-black text-[32px] font-bold md:text-[28px]"}>작가 리스트</span>
                    </div>

                    <AuthorFilterContainer
                        onFilterChange={(filters) => {
                            onFilterChange(filters);
                        }}
                        initialFilters={filters}
                    />


                    {showAlert && (
                        <AuthorFilterModal
                            key={JSON.stringify(selectedFilters)}
                            title="필터"
                            onClose={() => setShowAlert(false)}
                            onConfirm={handleConfirm}
                            initialFilters={selectedFilters}
                        />
                    )}
                    <AuthorCard authorCards={authors} initialFilters={filter}/>


                    <Paging totalPages={totalPages} currentPage={currentPage} onPageChange={onPageChange}/>

                </div>

            </div>


            <Footer/>

        </div>

    </>


    );
};

export default AuthorListPage;
